
  import { KanziWMSEnvironmentModel } from '@kanzi-apes/kanzi-models';
  export const environment: KanziWMSEnvironmentModel = {
    link_desk_help: '',
    environment: 'staging',
    template_purchase_orders: '',
    template_dispatch_orders: '',
    template_return_orders: '',
    template_transfer_orders: '',
    template_products: '',
    template_locations: '',
    template_optimal_route: 'https://wms-apeswmssandbox-wms-bucket-staging.s3.us-east-1.amazonaws.com/optimal_route/ruta_optima.csv',
    filter_warehouses_user:true,
    production: true,
    bucket_image_storage: '',
    QS_INVENTORY_DASHBOARD_NAME: '',
    cognitoConfig: {
      cognitoUserPoolId: 'us-east-1_QF2B5h5IS',
      cognitoAppClientId: 'cf9qbg1jgb4qudh59cmghurbj',
      cognitoRegion: '',
      cognitoIdentityPoolId: ''
    },
    qsApiUrlCommon: 'https://apes-qs-embed-api.technoapes.io/',
    tenantId: '9c512bfa',
    dataloaderHide: true,
    printOrders: {
      generatePrintFile: true,
      printAgent: true,
      printAgentUrl: 'https://localhost:5001/imprimir',
      defaultPrinterIp: '192.168.2.52',
    },
    apiRestModules: {
      kongWMSAPI: {
        locations: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'locations-v1',
        },
        locationsV3: {
          apiURL: 'https://ychqu8tbwg.execute-api.us-east-1.amazonaws.com/staging/',
          apiPath: 'locations-v3',
        },
        userConfigs: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'user-config',
        },
        thirdParties: {
          apiURL: 'https://api-2-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'third',
        },
        products: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'products',
        },
        productsV3: {
          apiURL: 'https://ctcs11swja.execute-api.us-east-1.amazonaws.com/staging/',
          apiPath: 'variant-v3',
        },
        stockProduct:{
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'inventory-lines',
        },
        stockProductV3:{
          apiURL: 'https://gxs72vko00.execute-api.us-east-1.amazonaws.com/staging/',
          apiPath: 'Inventory-lines',
        },
        users: {
          apiURL: 'https://api-2-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'users',
        },
        orders: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'dispatch-orders',
        },
        enlistmentOrders: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'enlistment-orders',
        },
        deliveryOrders: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'delivery-orders',
        },
        purchaseOrders: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'purchase-order-v1',
        },
        purchaseOrderLines: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'purchase-orders-v1',
        },        
        receiptsOrders: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'order-receipts',
        },
        returnsOrders: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'return-order',    
        },    
        locationTypes: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'location'         
        },
        reports: {
            apiURL: '',
            apiPath: 'qs/get-embed-url',
        },
        dataLoader: {
          apiURL: '',
          apiPath: 'master-files',
        },
        user_roles: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'user-roles',
        },
        user_creation: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'users-v1',
        },
        userConfigUpdate: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'user-configs',
        },
        inventoryCounts: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'inventory-counts',
        },
        types: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'types',
        },
        locationPriority: {
          apiURL: 'https://api-apeswmssandbox-staging.technoapes.io/',
          apiPath: 'location-priority'
        },
        containers: {
          apiURL: 'https://gxs72vko00.execute-api.us-east-1.amazonaws.com/staging/',
          apiPath: 'api/v1/containers'
        },
        webhooks: {
          apiURL: 'https://wt9tg4ub79.execute-api.us-east-1.amazonaws.com/staging/',
          apiPath: 'webhooks',
        },
        replenishmentConfigs: {
          apiURL: 'https://gxs72vko00.execute-api.us-east-1.amazonaws.com/staging/',
          apiPath: 'api/v1/replenishment-configs',
        },
        replenishmentTasks: {
          apiURL: 'https://gxs72vko00.execute-api.us-east-1.amazonaws.com/staging/',
          apiPath: 'api/v1/replenishment-tasks',
        }
      }
    }}; 